import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['timerType']

    connect() {
        // Port of assets.disable_remove
        // FIXME: remove when we delete assets.js
        document.querySelectorAll('.inherited-assets').forEach((element, index) => {
            const visibleAssets = element.querySelectorAll(
                '.inherited-asset:not([style*="display: none"])',
            )
            const removeButtons = element.querySelectorAll('.remove-inherited-asset')

            if (visibleAssets.length == 1) {
                removeButtons.forEach((button) => button.setAttribute('disabled', 'disabled'))
            } else {
                removeButtons.forEach((button) => button.removeAttribute('disabled'))
            }
        })
    }

    // Refresh the form to allow for a regenerated form
    // on the server based on the selected values. There is
    // already logic on the server for showing the right fields
    // based on the timer type. We don't want to duplicate the same logic
    // in the browser

    submitAsDraft() {
        // Create a hidden input dynamically for commit type
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'commit'
        input.value = 'draft'

        // Add it to the form
        const form = this.timerTypeTarget.closest('form')
        form.appendChild(input)

        // Submit the form using requestSubmit()
        form.requestSubmit()
    }
}
